import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetGoodsCodeResponse {
    product_code_idx: number;
    product_code_name: string;
    product_code: string;
}
export const useGetGoodsCode = (): UseQueryResult<GetGoodsCodeResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetGoodsCodeResponse[], Error>({
        queryKey: ["getGoodsCode"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_product_code}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
